export class TadInHoursFilter {
   dateStart: string;
   dateEnd: string;
   startTime: string;
   endTime: string;
   createdBy: string;
   registrationNumber: string;
   deleted: boolean;
}



// WEBPACK FOOTER //
// ./src/app/model/tadInHoursFilter.ts